// extracted by mini-css-extract-plugin
module.exports = {"changeTxt":"v3EJMPdT","tipsTxt":"qQ4FP8hO","inputBoxStyle":"SlDuXRFE"};